<template>
	<main class="school-mgn-list" style="background: #f5f5fb;">
		<section class="list-area">
			<div class="list-area-otis" style="height:auto" _p="x-10px y-10px">
        <el-form :inline="true" class="form" ref="filter_form" :model="filter_form">
          <el-form-item prop="fu_text_name">
            <InputTopTip v-model="filter_form.license" placeholder="激活码">
              <el-input
                v-model="filter_form.license"
                class="width-264"
                @keydown.enter.native.prevent="(page = 1), refreshDataList()"
                placeholder=""
                size="small"
              ></el-input>
            </InputTopTip>
          </el-form-item>
          <el-form-item prop="title">
            <InputTopTip v-model="filter_form.title" placeholder="课件名称">
              <el-input
                v-model="filter_form.title"
                class="width-264"
                @keydown.enter.native.prevent="(page = 1), refreshDataList()"
                placeholder=""
                size="small"
              ></el-input>
            </InputTopTip>
          </el-form-item>

          <el-form-item prop="publisher_id">
            <InputTopTip v-model="filter_form.publisher_id" placeholder="出版社">
              <el-select
                v-model="filter_form.publisher_id"
                size="small"
                placeholder=""
                class="width-121"
                @change=";(page = 1), refreshDataList()"
              >
                <el-option v-for="item in publisherIdTags" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </InputTopTip>
          </el-form-item>

          <el-form-item prop="region_code">
             <InputTopTip v-model="filter_form.region_code" :placeholder="'辖区'">
                <el-cascader
                  ref="areaRef"
                  v-model="filter_form.region_code"
                  style="width: 100%;"
                  size="small"
                  placeholder=""
                  :options="options"
                  :props="{
                    value: 'id',
                    label: 'name',
                    children: 'child',
                    emitPath: false,
                    checkStrictly: true
                  }"
                  @change="(page = 1), refreshDataList()"
                />
              </InputTopTip>
          </el-form-item>

           <el-form-item prop="school">
            <InputTopTip v-model="filter_form.school" placeholder="学校">
              <el-input
                v-model="filter_form.school"
                class="width-264"
                @keydown.enter.native.prevent="(page = 1), refreshDataList()"
                placeholder=""
                size="small"
              ></el-input>
            </InputTopTip>
          </el-form-item>

          <el-form-item prop="bbb">
            <el-date-picker
              v-model="filter_form.bbb"
              type="daterange"
              size="small"
              range-separator="——"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change=";(page = 1), refreshDataList()"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="mobile">
            <InputTopTip v-model="filter_form.mobile" placeholder="手机号码">
              <el-input
                v-model="filter_form.mobile"
                class="width-264"
                @keydown.enter.native.prevent="(page = 1), refreshDataList()"
                placeholder=""
                size="small"
              ></el-input>
            </InputTopTip>
          </el-form-item>
          <el-form-item prop="tag_value">
            <InputTopTip v-model="filter_form.tag_value" placeholder="标签">
              <el-select
                v-model="filter_form.tag_value"
                size="small"
                placeholder=""
                class="width-121"
                @change=";(page = 1), refreshDataList()"
              >
                <el-option v-for="item in tagValue.slice(1)" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </InputTopTip>
          </el-form-item>

        </el-form>
        <div style="display: flex; margin-left: auto;">
          <el-button
            type="primary"
            @click=";(page = 1), refreshDataList()"
            size="small"
            class="action-btn"
            style="margin-right: 15px; width: 70px;"
            >搜索</el-button
          >
          <el-button @click="restForm('filter_form')" size="small" style="width: 70px;">重置</el-button>
        </div>
			</div>

      <div _p="x-15px y-20px" _m="t-10px" _bg="[#fff]">
        <el-button
					size="small"
					icon="el-icon-download"
          v-if="($store.state.user.userInfo.type !== $api.account.types.TEACHER.value)"
					style="background: #f7f8fa; border: 2px solid #f7f8fa; color: #4b4b4b !important;margin-bottom: 15px;"
					@click="exportXLS"
					>下载</el-button
				>

        <el-table
          :data="tableData"
          ref="multipleTable"
          tooltip-effect="dark"
          width="100%"
        >
          <el-table-column prop="license_id" label="激活码" align="left"></el-table-column>
          <el-table-column prop="account.realname" label="教师"	align="left"></el-table-column>
          <el-table-column prop="account.login_name" label="账号"	align="left"></el-table-column>
          <el-table-column prop="account.mobile" label="手机号码"	align="left"></el-table-column>
          <el-table-column
            prop="name"
            label="辖区"
            align="left"
          >
            <template v-slot:default="slot">
              <template v-for="(teachers, index) in slot.row.account?.teachers">
                <span :key="index"
                  ><!-- {{index+1}}.&nbsp; -->{{ teachers.school?.district_division?.l1_name }}
                  {{ teachers.school?.district_division?.l2_name }} {{ teachers.school?.district_division?.l3_name || '' }}<br
                /></span>
              </template>
            </template>
          </el-table-column>
          <el-table-column
            prop="music_type"
            label="学校"
            align="left"
          >
            <template v-slot:default="slot">
              <template v-for="(teachers, index) in slot.row.account?.teachers">
                <span :key="index"><!-- {{index+1}}.&nbsp; -->{{ teachers?.school?.name }} <br /></span>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="publisher.name" label="出版社" align="left"></el-table-column>
          <el-table-column prop="import_title" label="导入课件名称" align="left"></el-table-column>
          <el-table-column label="标签" width="80px" align="center">
            <template slot-scope="scope">
              <span :style="
                {
                  background: tagValue.find(item => item.id == (scope.row?.tag_value || 0))?.background,
                  color: tagValue.find(item => item.id == (scope.row?.tag_value || 0))?.color,
                  padding: '13px 10px',
                  borderRadius: '14px',
                  fontWeight: '600',
                }"
              >
                {{ tagValue.find(item => item.id == (scope.row?.tag_value || 0))?.name }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="导入时间" align="left"></el-table-column>
          <el-table-column prop="expired_at" label="失效时间" align="left"></el-table-column>
        </el-table>

      </div>
			<div class="pagination-page">
				<span class="pagetotal">总计：{{ totalItems }}条/{{ Math.ceil(totalItems / pageSize) }}页</span>
				<el-pagination
					class="pagination"
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-size="pageSize"
					:total="totalItems"
					:current-page.sync="page"
					:page-sizes="[10, 20, 50, 100]"
					layout="prev,pager,next,jumper,sizes"
					style="margin-top: 21px; margin-left: 10px;"
				>
				</el-pagination>
			</div>
		</section>
	</main>
</template>
<script>
const ErrorImg = require('@/assets/test_client/reviewing@2x.png')
const ErrorImzxc = require('@/assets/test_client/sucess_icon@2x.png')
const puin = require('@/assets/test_client/puin.png')
const gansing = require('@/assets/test_client/gansin.png')
import { exporEquitytXLS } from '@/utils/job.js'
import { mapValues } from 'lodash'
export default {
	data() {
		return {
      tagValue: [
        { id: 0, name: '', background: '', color: '' },
        { id: 1, name: '入校', background: '#FFEBEB', color: '#E86363' },
        { id: 2, name: '测试', background: '#E0F8E3', color: '#428D47' },
      ],
			ErrorImg,
			ErrorImzxc,
			puin,
			gansing,
			tableData: [], // 用户列表
			multipleSelection: [],
			page: 1, // 第几页
			totalItems: 0, //总数
			pageSize: 10, // 每页的条数据
			filter_form: {
        license: '',
        title: '',
        publisher_id: '',
        region_code: '',
        school: '',
        tag_value: '',
        mobile: '',
        bbb: [],
      },
      publisherIdTags: [],
      options: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
		}
	},
	created() {
    try {
      this.getPublisherId()
      this.RegionalLevel()
      const { page, page_size, license, publisher_id, region_code, start, end, school, title, tag_value, mobile } = this.$store.state.searchParams[this.$route.name]
      this.page = page
      this.page_size = page_size
      this.filter_form.license = license
      this.filter_form.license = publisher_id
      this.filter_form.license = region_code
      this.filter_form.bbb = [start || '', end || '']
      this.filter_form.school = school
      this.filter_form.title = title
      this.filter_form.tag_value = Number(tag_value) || ''
      this.filter_form.mobile = mobile
      this.refreshDataList()
    } catch (_) {
      this.refreshDataList()
    }
	},
	methods: {
    restForm(name) {
      this.$refs[name].resetFields()
      this.filter_form = mapValues(this.filter_form, () => '')
      this.refreshDataList()
    },
		//获取列表数据
		async refreshDataList() {
      const params = {
				page: this.page,
				page_size: this.pageSize,
        ...this.filter_form,
        start: this.filter_form.bbb ? this.filter_form.bbb[0] : '',
        end: this.filter_form.bbb ? this.filter_form.bbb[1] : '',
        tag_value: this.filter_form.tag_value,
        mobile: this.filter_form.mobile
			}
      delete params.bbb
      this.$store.commit('setSearchParams', { key: this.$route.name, params})
			let res = null
			res = await this.$api.exam_activity.list(params)
			this.totalItems = res.meta.total
			this.tableData = res.data
		},
    async getPublisherId() {
			const { data } = await this.$api.question_set.getPublisherId()
			this.publisherIdTags = data
		},
    async RegionalLevel() {
			this.$api.school
				.ssxlist(0)
				.then(res => {
					this.options = this.removeEmptyItems(res)
				})
				.catch(err => {
					console.log('获取列表报错')
				})
		},
    removeEmptyItems(arr) {
			const newArr = []
			for (let i = 0; i < arr.length; i++) {
				const item = arr[i]
				if (item.child?.length >= 1) {
					item.child = this.removeEmptyItems(item.child)
				} else {
					item.child = undefined
				}
				newArr.push(item)
			}
			return newArr
		},    //每页下拉只显示的数据
		handleSizeChange(val) {
      this.page = 1
			this.pageSize = val
			this.refreshDataList()
		},
		//当前点击的是第几页
		handleCurrentChange(page) {
			this.page = page
			this.refreshDataList()
		},
    // 权益导出
		async exportXLS() {
			let title = `权益数据`
      const params = {
				page: this.page,
				page_size: this.pageSize,
        ...this.filter_form,
        start: this.filter_form.bbb ? this.filter_form.bbb[0] : '',
        end: this.filter_form.bbb ? this.filter_form.bbb[1] : '',
        tag_value: this.filter_form.tag_value,
        mobile: this.filter_form.mobile
			}
      delete params.bbb
			const { id } = await this.$api3.user.httpPost('exports/license-record', params)
			let job = {
				job_id: id,
				name: `${title}.xls`,
				type: 'XLS',
        msgType: 'exports/license-record',
				stop: false
			}
      exporEquitytXLS(this, job)
			this.$store.state.job.isDot = true
		},
	}
}
</script>
<style lang="scss" scoped>
.school-mgn-list .el-table {
	min-height: 690px;
}
.list-area-qy {
	width: 80px;
	height: 28px;
	font-size: 18px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #3e3e3e;
	line-height: 28px;
	-webkit-background-clip: text;
}

/deep/.el-table thead th {
	background-color: #fafafa;
	border-top: 1px solid #fff;
}
.pagetotal {
	width: 200px;
	margin-left: 20px;
	font-size: 14px;
	line-height: 70px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.pagination {
	width: 100%;
	margin-top: 20px;
	text-align: right;
}
.dotClass {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	display: block;
}
.el-form-item {
	margin-bottom: 1px;
}
// 列表操作图标
.table-mgn4 {
	width: 200px;
	display: flex;
	font-size: 16px;
	color: #999999;
	div {
		cursor: pointer;
		height: 28px;
		width: 28px;
		border: 1px solid #ebeef5;
		border-radius: 14px;
		margin-right: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		&.delete {
			border: 1px solid #fdeaec;
		}
	}
}

.el-dialog {
	border-radius: 15px;
}
.dialog-title {
	font-size: 20px;
	color: #21a74a;
	display: flex;
	justify-content: space-between;
	.icon {
		font-size: 24px;
		margin-right: 4px;
	}
}
.pagination-page {
	height: 60px;
	display: flex;
	justify-content: left;
	align-items: left;
}
.exp-blue {
	margin-left: 10px;
	color: #21a74a !important; //rgb(255, 255, 255)
}
.del-red {
	color: rgb(227, 23, 13) !important;
}
.school-district-mgn-list {
	.el-table {
		min-height: 504px;
	}
	.action-btn-block {
		height: 60px;
		padding-top: 20px;

		.action-btn {
			float: right;
			margin-right: 20px;
		}
	}
	.opscol div.cell > a {
		margin-right: 0.5em;

		&:last-child {
			margin-right: 0;
		}
	}
}

.btn:focus {
	outline: none;
	box-shadow: none;
}
</style>
